"use client"

import { useEffect, useMemo, useState } from "react"

import type { SupabaseUserWithMetadata } from "@/types/Supabase"
import { ClientUtils } from "@/utils/client/ClientUtils"
import { SupabaseSharedUtils } from "@/utils/shared/SupabaseSharedUtils"

export function useGetSupaUser() {
  const [user, setUser] = useState<SupabaseUserWithMetadata>()

  useEffect(() => {
    const supabase = ClientUtils.getClientSupabase()
    supabase.auth.getUser().then(({ data: { user } }) => {
      if (user) {
        setUser(SupabaseSharedUtils.transformToSupabaseUserWithMetadata(user))
      }
    })
  }, [])

  return useMemo(() => user, [user])
}
